import { API_URL } from "../../constants/pathConstants"

class RegisterConnector {
	requestInProgress: boolean = false

	public async performRegisterRequest(name: string, email: string, password: string, phoneNumber: string, dob: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [RegisterConnector] performRegisterRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let registerSuccess = false

				await fetch(`${API_URL}register`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password,
						"name": name,
						"phoneNumber": phoneNumber,
						"dob": dob
					})
				})
					.then((res) => res.json())
					// .then((data: LoginResponse) => {
					.then((data) => {
						if (data.status === 'success') {
							// userStateData.userData = data.userData
							// userStateData.loggedIn = false
							// this.requestInProgress = false
							// return true
							registerSuccess = true
						} else {
							// this.requestInProgress = false
							// return false
							registerSuccess = false
						}
						// console.log('login data =', data)
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return registerSuccess // userStateData.loggedIn // true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[RegisterConnector] - performRegisterRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performInstructorRegisterRequest(name: string, email: string, password: string, school: number, gender: number, activity: number, phoneNumber: string, dob: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [RegisterConnector] performRegisterRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let registerSuccess = false

				await fetch(`${API_URL}instructor-register`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password,
						"name": name,
						"phoneNumber": phoneNumber,
						"dob": dob,
						"school": school,
						"gender": `${gender}`,
						"activity": activity
					})
				})
					.then((res) => res.json())
					// .then((data: LoginResponse) => {
					.then((data) => {
						if (data.status === 'success') {
							// userStateData.userData = data.userData
							// userStateData.loggedIn = false
							// this.requestInProgress = false
							// return true
							registerSuccess = true
						} else {
							// this.requestInProgress = false
							// return false
							registerSuccess = false
						}
						// console.log('login data =', data)
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return registerSuccess // userStateData.loggedIn // true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[RegisterConnector] - performRegisterRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const registerConnector: RegisterConnector = new RegisterConnector()